<template>
  <div>
    <v-btn x-small icon @click.stop="dialog_ativo = true;buscarProdutos();">
      <v-icon small>mdi-information-outline</v-icon>
    </v-btn>

    <v-dialog
      v-model="dialog_ativo"
      titulo="Detalhamento da categoria"
      width="900"
      content-class="bra-20"
    >
      <v-card>
        <v-card-title>
          <span>Detalhamento da categoria</span>

          <v-spacer />

          <v-btn icon @click.stop="dialog_ativo = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pa-0">
          <DescricaoNivelLinha :linha="categoria" class="ml-6" />

          <v-tabs v-model="tab_ativo" centered>
            <v-tab class="font-13" href="#materia_prima">Materia prima</v-tab>
            <v-tab class="font-13" href="#acabado">Produto acabado</v-tab>
          </v-tabs>

          <v-data-table
            height="300"
            :headers="CABECALHO_COMPUTED"
            :items="ITENS"
            hide-default-footer
            fixed-header
            class="font-12-data-table ml-6 mr-0 pb-5"
          >
            <template #item.estoque="{ item }">
              {{ formatarNumero(item.estoque) }}
            </template>

            <template #item.peso="{ item }">
              {{ formatarNumero(item.peso) }}
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {buscarProdutosCategoria} from "@/api/compras/MateriaPrima";
import {formatarValor, logout} from "@/helpers";
import DescricaoNivelLinha from "../Helpers/DescricaoNivelLinha.vue";

export default {
  name: "DetalhamentoCategoria",
  components: {
    DescricaoNivelLinha
  },
  props: {
    categoria: Object
  },
  data: () => ({
    dialog_ativo: false,
    tab_ativo: 'materia_prima',
    cabecalhos: [
      { text: 'Id produto', value: 'idproduto' },
      { text: 'Descricao do produto', value: 'descricao_produto' },
      { text: 'Peso proporção', value: 'peso' },
    ],
    produtos: []
  }),
  computed: {
    CABECALHO_COMPUTED() {
      if (this.tab_ativo === 'materia_prima') {
        return this.cabecalhos.filter(item => item.value !== 'peso');
      }

      return this.cabecalhos;
    },
    ITENS () {
      return this.produtos[this.tab_ativo];
    },
    GRUPO_COMPRA() {
      return this.$store.getters["usuario/getGrupoCompras"];
    }
  },
  methods: {
    formatarNumero: formatarValor,
    buscarProdutos() {
      if (this.produtos.length > 0) return;

      const {id_grupo, idcategoria} = this.categoria;

      this.$store.dispatch('loading/addRequisicao',
        buscarProdutosCategoria({id_grupo, idcategoria})
          .then(produtos => (this.produtos = produtos))
          .catch(logout)
      );
    }
  }
}
</script>

<style scoped>
</style>
